import type { Look } from './types';

/**
 * Inheritance of a card's look: the card's own override wins; otherwise the default look of its
 * column; otherwise the standard card. The board look is a different layer (the page behind the
 * columns) and never changes cards.
 */
export function effectiveCardLook(
  card: { appearance: Look | null },
  column: { card_look: Look | null } | undefined,
): Look | null {
  return card.appearance ?? column?.card_look ?? null;
}

/** Where the effective look of a card comes from (for the editor's "inherits" hint). */
export function cardLookSource(
  card: { appearance: Look | null },
  column: { card_look: Look | null } | undefined,
): 'own' | 'column' | 'standard' {
  if (card.appearance) return 'own';
  return column?.card_look ? 'column' : 'standard';
}
